import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import { BmBanksResponse } from "../models/bm-banks.resposne";
import { RequestBlueMediaUrl, RequestBlueMediaUrlResponse } from "../models/request.url.dto";

interface BmBanksListResponse {
  list: BmBanksResponse[]
}

export class BlueMediaService{
    private readonly _client: HttpClient;
    private readonly _url = "bm";
    constructor() {
        this._client = new HttpClient(Environment.apiUrl);
    }

    public async getBanks(): Promise<BmBanksResponse[]> {
        const url = `${this._url}/bankList`;
        const response = await this._client.post<BmBanksListResponse, {}>(url, {}, true);
        return response.data.list;
    }

    public async getVerificationUrl(dto : RequestBlueMediaUrl): Promise<RequestBlueMediaUrlResponse>{
        const url = `${this._url}/url`;
        return (await this._client.post<RequestBlueMediaUrlResponse, RequestBlueMediaUrl>(url, dto, true)).data;
    }

}